
<mat-dialog-content *ngIf="!editBlog">
  <form [formGroup]="blogForm" class="mt-4">
    <mat-card class="blog-card">
      <div class="gradient-title">Add Blog</div>
      <!-- <mat-card-content> -->

        <!--Language Button-->
        <div class="cus-button">
          <button (click)="setLanguage('english')">English</button>
          <button (click)="setLanguage('french')">French</button>
          <button (click)="setLanguage('spanish')">Spanish</button>
          <button (click)="setLanguage('portuguese')">Portuguese</button>
      </div>


      <!--For eng-->
      <div class="english" *ngIf="languageSelected === 'english'">
      <div class="input-container">
        <label for="routing_title">Routing Title For English(Format: example-a, test-b)</label>
        <input type="text" formControlName="routing_titleen" id="routing_title" maxlength="100" name="routing_title" required />
      </div>

      <div class="input-container">
        <label for="title">Blog Title For English</label>
        <input type="text" formControlName="titleen" id="title" name="title" required />
      </div>

      <div class="input-container">
        <label for="image">Add Header Image For English</label>
        <div class="custom-file-input">
          <label for="image" class="custom-file-label">Choose Image For English (750 x 450)</label>
          <input type="file" (change)="onImageChange($event)" formControlName="imageen" id="image" accept="image/*"  name="image" />
        </div>
      </div>
        <div class="input-container">
          <label for="title">SEO Title For English (Between 50–60 Characters)</label>
          <input type="text" formControlName="seotitleen" id="subtitle" name="subtitle" maxlength="60" />
        </div>
        <div class="input-container">
          <label for="title">SEO Description For English (Between 150–160 characters)</label>
          <input type="text" formControlName="seodescriptionen" id="subtitle" name="subtitle" maxlength="160"/>
        </div>
        <div class="input-container">
          <label for="title">SEO Keywords For English (Between 3–5 primary keywords)</label>
          <input type="text" formControlName="seokeyworden" id="subtitle" name="subtitle" />
        </div>
      <div class="quill-editor-wrapper">
        <label for="title">Add Content For English</label>
        <quill-editor formControlName="contenten" style="min-width: 300px; width: 100%;"></quill-editor>
      </div>

        <!-- ✅ CTA Button One -->
      <div class="cta-container mt-2">
        <label>
          <input type="checkbox" formControlName="cta_button_one_enableden">
          Enable CTA Button One
        </label>
        <button (click)="toggleAction()" class="toggle-btn" *ngIf="blogForm.get('cta_button_one_enableden')?.value"
            [ngClass]="{'popup-btn': blogForm.get('togglecontrol')?.value}">
            {{ blogForm.get('togglecontrol')?.value ? 'Set URL' : 'Set Popup' }}
        </button>
        <!-- Fields will only be shown if the checkbox is checked -->
        <div *ngIf="blogForm.get('cta_button_one_enableden')?.value">
          <input type="text" formControlName="cta_button_one_texten" placeholder="Enter button name" />
          <input type="text" formControlName="cta_button_one_linken"  *ngIf="!blogForm.get('togglecontrol')?.value" placeholder="Enter button link" />
          <input type="text" formControlName="cta_button_one_source_nameen"  *ngIf="blogForm.get('togglecontrol')?.value" placeholder="Enter Landingpage Source Name" />
        </div>
      </div>

      <!-- ✅ CTA Button Two -->
      <div class="cta-container mt-2">
        <label>
          <input type="checkbox" formControlName="cta_button_two_enableden">
          Enable CTA Button Two
        </label>
        <button (click)="toggleAction1()" class="toggle-btn" *ngIf="blogForm.get('cta_button_two_enableden')?.value"
            [ngClass]="{'popup-btn': blogForm.get('togglecontrol1')?.value}">
            {{ blogForm.get('togglecontrol1')?.value ? 'Set URL' : 'Set Popup' }}
        </button>
        <!-- Fields will only be shown if the checkbox is checked -->
        <div *ngIf="blogForm.get('cta_button_two_enableden')?.value">
          <input type="text" formControlName="cta_button_two_texten" placeholder="Enter button name" />
          <input type="text" formControlName="cta_button_two_linken" *ngIf="!blogForm.get('togglecontrol1')?.value" placeholder="Enter button link" />
          <input type="text" formControlName="cta_button_two_source_nameen" *ngIf="blogForm.get('togglecontrol1')?.value" placeholder="Enter Landingpage Source Name" />
        </div>
      </div>
    </div>



    <!--French-->
    <div class="french" *ngIf="languageSelected === 'french'">
      <div class="input-container">
        <label for="routing_title">Routing Title For French(Format: example-a, test-b)</label>
        <input type="text" formControlName="routing_titlefr" id="routing_title" maxlength="100" name="routing_title" required />
      </div>

      <div class="input-container">
        <label for="title">Blog Title For French</label>
        <input type="text" formControlName="titlefr" id="title" name="title" required />
      </div>

      <div class="input-container">
        <label for="image">Add Header Image For French</label>
        <div class="custom-file-input">
          <label for="image" class="custom-file-label">Choose Image For French (750 x 450)</label>
          <input type="file" (change)="onImageChange($event)" formControlName="imagefr" id="image" accept="image/*"  name="image" />
        </div>
      </div>
        <div class="input-container">
          <label for="title">SEO Title For French (Between 50–60 Characters)</label>
          <input type="text" formControlName="seotitlefr" id="subtitle" name="subtitle" maxlength="60" />
        </div>
        <div class="input-container">
          <label for="title">SEO Description For French (Between 150–160 characters)</label>
          <input type="text" formControlName="seodescriptionfr" id="subtitle" name="subtitle" maxlength="160"/>
        </div>
        <div class="input-container">
          <label for="title">SEO Keywords For French (Between 3–5 primary keywords)</label>
          <input type="text" formControlName="seokeywordfr" id="subtitle" name="subtitle" />
        </div>
      <div class="quill-editor-wrapper">
        <label for="title">Add Content For French</label>
        <quill-editor formControlName="contentfr" style="min-width: 300px; width: 100%;"></quill-editor>
      </div>
        <!-- ✅ CTA Button One -->
      <div class="cta-container mt-2">
        <label>
          <input type="checkbox" formControlName="cta_button_one_enabledfr">
          Enable CTA Button One
        </label>
        <button (click)="toggleAction()" class="toggle-btn" *ngIf="blogForm.get('cta_button_one_enabledfr')?.value"
            [ngClass]="{'popup-btn': blogForm.get('togglecontrol')?.value}">
            {{ blogForm.get('togglecontrol')?.value ? 'Set URL' : 'Set Popup' }}
        </button>
        <!-- Fields will only be shown if the checkbox is checked -->
        <div *ngIf="blogForm.get('cta_button_one_enabledfr')?.value">
          <input type="text" formControlName="cta_button_one_textfr" placeholder="Enter button name" />
          <input type="text" formControlName="cta_button_one_linkfr"  *ngIf="!blogForm.get('togglecontrol')?.value" placeholder="Enter button link" />
          <input type="text" formControlName="cta_button_one_source_namefr"  *ngIf="blogForm.get('togglecontrol')?.value" placeholder="Enter Landingpage Source Name" />
        </div>
      </div>

      <!-- ✅ CTA Button Two -->
      <div class="cta-container mt-2">
        <label>
          <input type="checkbox" formControlName="cta_button_two_enabledfr">
          Enable CTA Button Two
        </label>
        <button (click)="toggleAction1()" class="toggle-btn" *ngIf="blogForm.get('cta_button_two_enabledfr')?.value"
            [ngClass]="{'popup-btn': blogForm.get('togglecontrol1')?.value}">
            {{ blogForm.get('togglecontrol1')?.value ? 'Set URL' : 'Set Popup' }}
        </button>
        <!-- Fields will only be shown if the checkbox is checked -->
        <div *ngIf="blogForm.get('cta_button_two_enabledfr')?.value">
          <input type="text" formControlName="cta_button_two_textfr" placeholder="Enter button name" />
          <input type="text" formControlName="cta_button_two_linkfr" *ngIf="!blogForm.get('togglecontrol1')?.value" placeholder="Enter button link" />
          <input type="text" formControlName="cta_button_two_source_namefr" *ngIf="blogForm.get('togglecontrol1')?.value" placeholder="Enter Landingpage Source Name" />
        </div>
      </div>
    </div>
<!---->


<!--Spanish-->

<div class="spanish" *ngIf="languageSelected === 'spanish'">
  <div class="input-container">
    <label for="routing_title">Routing Title For Spanish (Format: example-a, test-b)</label>
    <input type="text" formControlName="routing_titlees" id="routing_title" maxlength="100" name="routing_title" required />
  </div>

  <div class="input-container">
    <label for="title">Blog Title For Spanish</label>
    <input type="text" formControlName="titlees" id="title" name="title" required />
  </div>

  <div class="input-container">
    <label for="image">Add Header Image For Spanish</label>
    <div class="custom-file-input">
      <label for="image" class="custom-file-label">Choose Image For Spanish (750 x 450)</label>
      <input type="file" (change)="onImageChange($event)" formControlName="imagees" id="image" accept="image/*"  name="image" />
    </div>
  </div>
    <div class="input-container">
      <label for="title">SEO Title For Spanish (Between 50–60 Characters)</label>
      <input type="text" formControlName="seotitlees" id="subtitle" name="subtitle" maxlength="60" />
    </div>
    <div class="input-container">
      <label for="title">SEO Description For Spanish (Between 150–160 characters)</label>
      <input type="text" formControlName="seodescriptiones" id="subtitle" name="subtitle" maxlength="160"/>
    </div>
    <div class="input-container">
      <label for="title">SEO Keywords For Spanish (Between 3–5 primary keywords)</label>
      <input type="text" formControlName="seokeywordes" id="subtitle" name="subtitle" />
    </div>
  <div class="quill-editor-wrapper">
    <label for="title">Add Content For Spanish</label>
    <quill-editor formControlName="contentes" style="min-width: 300px; width: 100%;"></quill-editor>
  </div>
    <!-- ✅ CTA Button One -->
  <div class="cta-container mt-2">
    <label>
      <input type="checkbox" formControlName="cta_button_one_enabledes">
      Enable CTA Button One
    </label>
    <button (click)="toggleAction()" class="toggle-btn" *ngIf="blogForm.get('cta_button_one_enabledes')?.value"
        [ngClass]="{'popup-btn': blogForm.get('togglecontrol')?.value}">
        {{ blogForm.get('togglecontrol')?.value ? 'Set URL' : 'Set Popup' }}
    </button>
    <!-- Fields will only be shown if the checkbox is checked -->
    <div *ngIf="blogForm.get('cta_button_one_enabledes')?.value">
      <input type="text" formControlName="cta_button_one_textes" placeholder="Enter button name" />
      <input type="text" formControlName="cta_button_one_linkes"  *ngIf="!blogForm.get('togglecontrol')?.value" placeholder="Enter button link" />
      <input type="text" formControlName="cta_button_one_source_namees"  *ngIf="blogForm.get('togglecontrol')?.value" placeholder="Enter Landingpage Source Name" />
    </div>
  </div>

  <!-- ✅ CTA Button Two -->
  <div class="cta-container mt-2">
    <label>
      <input type="checkbox" formControlName="cta_button_two_enabledes">
      Enable CTA Button Two
    </label>
    <button (click)="toggleAction1()" class="toggle-btn" *ngIf="blogForm.get('cta_button_two_enabledes')?.value"
        [ngClass]="{'popup-btn': blogForm.get('togglecontrol1')?.value}">
        {{ blogForm.get('togglecontrol1')?.value ? 'Set URL' : 'Set Popup' }}
    </button>
    <!-- Fields will only be shown if the checkbox is checked -->
    <div *ngIf="blogForm.get('cta_button_two_enabledes')?.value">
      <input type="text" formControlName="cta_button_two_textes" placeholder="Enter button name" />
      <input type="text" formControlName="cta_button_two_linkes" *ngIf="!blogForm.get('togglecontrol1')?.value" placeholder="Enter button link" />
      <input type="text" formControlName="cta_button_two_source_namees" *ngIf="blogForm.get('togglecontrol1')?.value" placeholder="Enter Landingpage Source Name" />
    </div>
  </div>
</div>

      <!--POrtuguese-->

      <div class="portuguese" *ngIf="languageSelected === 'portuguese'">
        <div class="input-container">
          <label for="routing_title">Routing Title For Portuguese(Format: example-a, test-b)</label>
          <input type="text" formControlName="routing_titlept" id="routing_title" maxlength="100" name="routing_title" required />
        </div>

        <div class="input-container">
          <label for="title">Blog Title For Portuguese</label>
          <input type="text" formControlName="titlept" id="title" name="title" required />
        </div>

        <div class="input-container">
          <label for="image">Add Header Image For Portuguese</label>
          <div class="custom-file-input">
            <label for="image" class="custom-file-label">Choose Image(750 x 450)</label>
            <input type="file" (change)="onImageChange($event)" formControlName="imagept" id="image" accept="image/*"  name="image" />
          </div>
        </div>
          <div class="input-container">
            <label for="title">SEO Title For Portuguese (Between 50–60 Characters)</label>
            <input type="text" formControlName="seotitlept" id="subtitle" name="subtitle" maxlength="60" />
          </div>
          <div class="input-container">
            <label for="title">SEO Description For Portuguese (Between 150–160 characters)</label>
            <input type="text" formControlName="seodescriptionpt" id="subtitle" name="subtitle" maxlength="160"/>
          </div>
          <div class="input-container">
            <label for="title">SEO Keywords For Portuguese (Between 3–5 primary keywords)</label>
            <input type="text" formControlName="seokeywordpt" id="subtitle" name="subtitle" />
          </div>
        <div class="quill-editor-wrapper">
          <label for="title">Add Content For Portuguese</label>
          <quill-editor formControlName="contentpt" style="min-width: 300px; width: 100%;"></quill-editor>
        </div>
          <!-- ✅ CTA Button One -->
        <div class="cta-container mt-2">
          <label>
            <input type="checkbox" formControlName="cta_button_one_enabledpt">
            Enable CTA Button One
          </label>
          <button (click)="toggleAction()" class="toggle-btn" *ngIf="blogForm.get('cta_button_one_enabledpt')?.value"
              [ngClass]="{'popup-btn': blogForm.get('togglecontrol')?.value}">
              {{ blogForm.get('togglecontrol')?.value ? 'Set URL' : 'Set Popup' }}
          </button>
          <!-- Fields will only be shown if the checkbox is checked -->
          <div *ngIf="blogForm.get('cta_button_one_enabledpt')?.value">
            <input type="text" formControlName="cta_button_one_textpt" placeholder="Enter button name" />
            <input type="text" formControlName="cta_button_one_linkpt"  *ngIf="!blogForm.get('togglecontrol')?.value" placeholder="Enter button link" />
            <input type="text" formControlName="cta_button_one_source_namept"  *ngIf="blogForm.get('togglecontrol')?.value" placeholder="Enter Landingpage Source Name" />
          </div>
        </div>

        <!-- ✅ CTA Button Two -->
        <div class="cta-container mt-2">
          <label>
            <input type="checkbox" formControlName="cta_button_two_enabledpt">
            Enable CTA Button Two
          </label>
          <button (click)="toggleAction1()" class="toggle-btn" *ngIf="blogForm.get('cta_button_two_enabledpt')?.value"
              [ngClass]="{'popup-btn': blogForm.get('togglecontrol1')?.value}">
              {{ blogForm.get('togglecontrol1')?.value ? 'Set URL' : 'Set Popup' }}
          </button>
          <!-- Fields will only be shown if the checkbox is checked -->
          <div *ngIf="blogForm.get('cta_button_two_enabledpt')?.value">
            <input type="text" formControlName="cta_button_two_textpt" placeholder="Enter button name" />
            <input type="text" formControlName="cta_button_two_linkpt" *ngIf="!blogForm.get('togglecontrol1')?.value" placeholder="Enter button link" />
            <input type="text" formControlName="cta_button_two_source_namept" *ngIf="blogForm.get('togglecontrol1')?.value" placeholder="Enter Landingpage Source Name" />
          </div>
        </div>
      </div>


        <div class="submit-button">
          <button mat-raised-button color="primary" type="submit" (click)="onSubmit()" class="gradient-button">
            Save
          </button>
        </div>

    </mat-card>
  </form>
</mat-dialog-content>


<mat-dialog-content *ngIf="editBlog">
  <form [formGroup]="editBlogForm" class="mt-4">
    <mat-card class="blog-card">
      <div class="gradient-title">Edit Blog</div>
      <!-- <mat-card-content> -->

        <!-- Blog Title Field -->
        <div class="input-container">
          <label for="routing_title">Routing Title(Format: example-a, test-b)</label>
          <input type="text" formControlName="routing_title" id="routing_title" maxlength="100" name="routing_title" required />
        </div>

        <div class="input-container">
          <label for="title">Blog Title</label>
          <input type="text" formControlName="title" id="title" name="title" required />
        </div>

        <div class="input-container">
          <label for="image">Add Header Image</label>
          <div class="custom-file-input">
            <label for="image" class="custom-file-label">Choose Image(750 x 450)</label>
            <input type="file" (change)="onImageChange($event)" formControlName="image" id="image" accept="image/*"  name="image" />
          </div>
        </div>
          <div class="input-container">
            <label for="title">SEO Title (Between 50–60 Characters)</label>
            <input type="text" formControlName="seotitle" id="subtitle" name="subtitle" maxlength="60" />
          </div>
          <div class="input-container">
            <label for="title">SEO Description (Between 150–160 characters)</label>
            <input type="text" formControlName="seodescription" id="subtitle" name="subtitle" maxlength="160"/>
          </div>
          <div class="input-container">
            <label for="title">SEO Keywords (Between 3–5 primary keywords)</label>
            <input type="text" formControlName="seokeyword" id="subtitle" name="subtitle" />
          </div>
        <div class="quill-editor-wrapper">
          <label for="title">Add Content</label>
          <quill-editor formControlName="content" style="min-width: 300px; width: 100%;"></quill-editor>
        </div>
          <!-- ✅ CTA Button One -->
        <div class="cta-container mt-2">
          <label>
            <input type="checkbox" formControlName="cta_button_one_enabled">
            Enable CTA Button One
          </label>
          <button (click)="editToggleAction()" class="toggle-btn" *ngIf="editBlogForm.get('cta_button_one_enabled')?.value"
              [ngClass]="{'popup-btn': editBlogForm.get('togglecontrol')?.value}">
              {{ editBlogForm.get('togglecontrol')?.value ? 'Set URL' : 'Set Popup' }}
          </button>
          <!-- Fields will only be shown if the checkbox is checked -->
          <div *ngIf="editBlogForm.get('cta_button_one_enabled')?.value">
            <input type="text" formControlName="cta_button_one_text" placeholder="Enter button name" />
            <input type="text" formControlName="cta_button_one_link"  *ngIf="!editBlogForm.get('togglecontrol')?.value" placeholder="Enter button link" />
            <input type="text" formControlName="cta_button_one_source_name"  *ngIf="editBlogForm.get('togglecontrol')?.value" placeholder="Enter Landingpage Source Name" />
          </div>
        </div>

        <!-- ✅ CTA Button Two -->
        <div class="cta-container mt-2">
          <label>
            <input type="checkbox" formControlName="cta_button_two_enabled">
            Enable CTA Button Two
          </label>
          <button (click)="editToggleAction1()" class="toggle-btn" *ngIf="editBlogForm.get('cta_button_two_enabled')?.value"
              [ngClass]="{'popup-btn': editBlogForm.get('togglecontrol1')?.value}">
              {{ editBlogForm.get('togglecontrol1')?.value ? 'Set URL' : 'Set Popup' }}
          </button>
          <!-- Fields will only be shown if the checkbox is checked -->
          <div *ngIf="editBlogForm.get('cta_button_two_enabled')?.value">
            <input type="text" formControlName="cta_button_two_text" placeholder="Enter button name" />
            <input type="text" formControlName="cta_button_two_link" *ngIf="!editBlogForm.get('togglecontrol1')?.value" placeholder="Enter button link" />
            <input type="text" formControlName="cta_button_two_source_name" *ngIf="editBlogForm.get('togglecontrol1')?.value" placeholder="Enter Landingpage Source Name" />
          </div>
        </div>

        <div class="submit-button">
          <button mat-raised-button color="primary" type="submit" (click)="onEditSubmit()" class="gradient-button">
            Save
          </button>
        </div>

    </mat-card>
  </form>
</mat-dialog-content>
